import moment from 'moment';
import { useDayFirstDate } from './countries';

export const NBSP_STRING_LITERAL = '\xa0';

const breakOkay = char => char.match(/^[\s.-]$/);
export const truncate = (string, length, minLengthMultiplier = 0.5) => {
    let result = String(string);

    if (!result || result.length <= length) {
        return result;
    }

    const minLength = Math.floor(length * minLengthMultiplier);
    let amendedLength = length;

    while (!breakOkay(result[amendedLength]) && amendedLength > minLength) {
        amendedLength--;
    }
    result = result.substring(0, amendedLength);

    return result + (result !== string ? '…' : '');
};

// adapted ponyfill from MDN polyfill.  https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Polyfill
export const trim = string => string && string.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');

// parseZone will disregard the encoded timezone (cause in the AL API they're junk afaict)
// Country-aware date formatting: UK/Ireland uses day-first, US uses month-first
export var dateFormatLong = function(date, countryId) {
    if (!date) return null;
    var dayFirst = useDayFirstDate(countryId);
    // UK/IE: "Mon, 5 January" | US: "Mon, January 5"
    var format = dayFirst
        ? 'ddd,' + NBSP_STRING_LITERAL + 'D' + NBSP_STRING_LITERAL + 'MMMM'
        : 'ddd,' + NBSP_STRING_LITERAL + 'MMMM' + NBSP_STRING_LITERAL + 'D';
    return moment.parseZone(date).format(format);
};

export var dateFormatShort = function(date, countryId) {
    if (!date) return null;
    var dayFirst = useDayFirstDate(countryId);
    // UK/IE: "5 Jan" | US: "Jan 5"
    var format = dayFirst
        ? 'D' + NBSP_STRING_LITERAL + 'MMM'
        : 'MMM' + NBSP_STRING_LITERAL + 'D';
    return moment.parseZone(date).format(format);
};

export const dateFormatYear = date => date && moment.parseZone(date).format('YYYY');
export const splitTimeAmPm = time => {
    if (!time || !time.match)
        return;

    const result = time.match(/(\d?\d:\d\d) ([AP]M)/i);

    return result && result.length >= 3
        ? {time: result[1], ampm: result[2]}
        : undefined
};

// taken from https://developers.google.com/maps/documentation/urls/guide#forming-the-url
export const getGoogleMapsUrl = address => address && `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;